import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './styles.module.scss';
import cx from 'clsx';
import { forwardRef } from 'react';
import { getCurrentLocale } from '@clover-web-lib-sprout/common';
import { Spinner } from '@clover-web-lib-sprout/spinner';
import { getLanguageStrings } from './localizations';
const VARIANT_SPINNER_COLORS = {
    primary: {
        destructive: 'whiteSpinner',
        normal: 'whiteSpinner',
    },
    secondary: {
        destructive: 'redSpinner',
        normal: 'greenSpinner',
    },
    secondaryGray: {
        destructive: 'graySpinner',
        normal: 'graySpinner',
    },
    tertiary: {
        destructive: 'whiteSpinner',
        normal: 'blueSpinner',
    },
};
/**
 * Clover styled button.
 * Supports all props that can be applied to a native HTML `button` element. Unlike the native HTML `button` element
 * the `type` is `button` as default, so `submit` must be specified as the type explicitly when using for form submission.
 *
 * MDN Button docs: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Attributes
 */
/**
 * @title
 *  Button
 * @label
 *  Button
 * @shortdescription
 *  Clover styled button.
 * @keywords
 *  [Button,Clover button,Secondary, Tertiary, primary button]
 * @description
 * Clover styled button. Note: Use sentence case for the label!
 * Supports all props that can be applied to a native HTML `button` element. Unlike the native HTML `button` element
 * the `type` is `button` as default, so `submit` must be specified as the type explicitly when using for form submission.
 * MDN Button docs: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Attributes
 * @componentUsage
 * <Button variant={'secondary'} {...args} />
 * @example
 * <ButtonExample children={'Click me'}/>
 * @visibility
 * false
 */
export const Button = forwardRef(({ type = 'button', variant = 'primary', destructive, fullwidth, large, loading, className, children, language = getCurrentLocale(), ...passThroughProps }, ref) => {
    const text = getLanguageStrings(language);
    const spinnerColor = loading ? VARIANT_SPINNER_COLORS[variant][destructive ? 'destructive' : 'normal'] : undefined;
    return (_jsxs(_Fragment, { children: [_jsx("button", { type: type, ref: ref, "aria-disabled": loading, className: cx(styles.button, styles[variant], destructive && styles.destructive, fullwidth && styles.fullwidth, large && styles.large, styles.dots, className), ...passThroughProps, children: _jsxs("span", { className: cx(styles.loadingContainer), children: [loading && (_jsxs(_Fragment, { children: [_jsx("span", { className: cx(styles.busyState, destructive && styles.destructive), children: _jsx(Spinner, { spinnerVariant: spinnerColor, className: cx(styles.spinner) }) }), _jsx("span", { className: styles.reduceMotion, children: text.loading })] })), _jsx("span", { className: styles.btnChildren, children: children })] }) }), loading !== undefined && loading !== null && (_jsx("span", { className: styles.visuallyHidden, "aria-live": 'polite', children: loading && text.loading }))] }));
});
Button.displayName = 'Button';
//# sourceMappingURL=Button.js.map